import React from "react";
import {Item} from "@jnext/ts-axios-contestformat";
import './index.scss';
import {JCMSStaticModal} from "../JCMSStaticSections/components/JCMSStaticModal";
import { getProductImage } from "../lib/utils/product";
import {useTranslation} from "react-i18next";
import {CTAType} from "../models";

export interface RewardModalProps {
    onClose: () => void;
    quantityPerPeriod?: number;
    distributionType?: string;
    rewardItem: Item;
    text?: string;
    btnProps?: {
        title?: string;
        action?: () => void;
        type?: CTAType
    }
}

export const RewardModal: React.FC<RewardModalProps> = ({onClose,
                                                            rewardItem,
                                                            text,
                                                            quantityPerPeriod,
                                                            distributionType,
                                                            btnProps}) => {
    const { t } = useTranslation();

   /* const beforeText = <div className={'reward-info-message-container'}>
        <div className={'reward-info-message'}>Disponibile fino a Novembre 2021</div>
    </div>*/

    const quantity = quantityPerPeriod && distributionType ?
        <div className={'reward-quantity-container'}>
            <div className={'reward-quantity'}>
                <div className={'value'}>{quantityPerPeriod}</div>
                <span className={'label'}>{t(`DISTRIBUTION_${distributionType}`)}</span>
            </div>
        </div> : null;


    
    return <JCMSStaticModal
        open={true}
        onCancel={onClose}
        enabled={true}
        image={[
            {
                src: getProductImage(rewardItem?.product) || ''
            }
        ]}
        title={rewardItem?.product?.title}
        //beforeText={beforeText}
        text={text || rewardItem?.product?.longDescription}
        afterText={quantity}
        btnProps={btnProps}
    />
}